import { FC, useState } from 'react';

import { SkeletonBlock } from '../../atoms/SkeletonBlock';

import {
	StyledWordmarkFrame,
	StyledWordmarkImage,
	StyledWordmarkWrapper,
} from './MplOperatorWordmark.styled';

interface IMplOperatorWordmarkProps {
	/** Operator wordmark URL (BE `wordmarkUrl` / `operatorWordmarkUrl`). */
	src?: string;
	dataTestId?: string;
}

/**
 * Full-width operator wordmark strip shown atop ticketshop screens (ticket
 * detail, operator tickets). Reserves a fixed height so no layout shift occurs;
 * a centered skeleton stands in until the image loads. Renders nothing when no
 * URL is provided or the image fails to load.
 */
export const MplOperatorWordmark: FC<IMplOperatorWordmarkProps> = ({
	src,
	dataTestId,
}) => {
	const [loaded, setLoaded] = useState(false);
	const [error, setError] = useState(false);

	if (!src || error) {
		return null;
	}

	return (
		<StyledWordmarkWrapper>
			<StyledWordmarkFrame data-testid={dataTestId}>
				{!loaded && <SkeletonBlock w="80%" h={54} r={8} />}
				<StyledWordmarkImage
					src={src}
					alt=""
					loaded={loaded}
					onLoad={() => setLoaded(true)}
					onError={() => setError(true)}
				/>
			</StyledWordmarkFrame>
		</StyledWordmarkWrapper>
	);
};
